import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
// reuse strategy
import { RouteReuseStrategy } from '@angular/router';
import { CacheRouteReuseStrategy } from './core/cache-route-reuse.strategy';

import { IndexComponent } from './components/index/index.component';
import { AuthGuard } from 'src/app/guard/auth.guard'
import { LayoutComponent } from 'src/app/components/layouts/layout.component';

const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: '', component: IndexComponent
            },
            {
                path: 'about', loadChildren: () => import('./components/about/about.module').then(m => m.AboutModule)
            },
            {
                path: 'project', loadChildren: () => import('./components/project/project.module').then(m => m.ProjectModule)
            },
            {
                path: 'contact', loadChildren: () => import('./components/contact/contact.module').then(m => m.ContactModule)
            },
            {
                path: 'recruit', loadChildren: () => import('./components/recruit/recruit.module').then(m => m.RecruitModule)
            },
            { path: '**', redirectTo: '/', pathMatch: 'full' },

         
        ]
    },
   

];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload', useHash: false, enableTracing: false }),
        FormsModule,
        CommonModule

    ],
    exports: [RouterModule],
    providers: [
        {
            provide: RouteReuseStrategy,
            useClass: CacheRouteReuseStrategy
        }
    ]
})
export class AppRoutingModule { }

